// eslint-disable-next-line import/prefer-default-export
export function timeoutPromise(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
